/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * BfEventClassification : The physical event type that has occurred.
 */

export const BfEventClassification = {
    unknown: 'unknown',
    bushfire: 'bushfire',
    fire: 'fire',
    storm: 'storm',
    damagingWinds: 'damagingWinds',
    burn: 'burn',
    flood: 'flood',
    aircraftAccident: 'aircraftAccident',
    railAccident: 'railAccident',
    marineAccident: 'marineAccident',
    earthquake: 'earthquake',
    tsunami: 'tsunami',
    landslide: 'landslide',
    cycloneTornado: 'cycloneTornado',
    hazardousMaterial: 'hazardousMaterial',
    fallenPowerLines: 'fallenPowerLines',
    plague: 'plague',
    damFailure: 'damFailure',
    healthHazard: 'healthHazard',
    alarm: 'alarm',
    vehicleAccident: 'vehicleAccident',
    rescue: 'rescue',
    damage: 'damage',
    treeDown: 'treeDown',
    fireBan: 'fireBan',
    other: 'other',
    ambulance: 'ambulance',
    weather: 'weather',
    evacuation: 'evacuation',
    marine: 'marine',
    farming: 'farming',
    airQuality: 'airQuality',
    smoke: 'smoke',
    hail: 'hail',
    damagingSurf: 'damagingSurf',
    abnormalHighTide: 'abnormalHighTide',
    extremeHeat: 'extremeHeat',
    dangerousAnimal: 'dangerousAnimal',
    pandemic: 'pandemic',
    utilitySupply: 'utilitySupply',
    assistOtherAgency: 'assistOtherAgency',
    shark: 'shark',
    medical: 'medical',
    schoolClosure: 'schoolClosure',
    fireWeather: 'fireWeather',
    tornado: 'tornado'
} as const;

export type BfEventClassification = typeof BfEventClassification[keyof typeof BfEventClassification];



